import { AfterViewInit, ChangeDetectionStrategy, Input, ChangeDetectorRef, Component, EventEmitter, inject, Output, ViewChild } from '@angular/core';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { Mirko3Service } from '../mirko3.service';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatPaginator, MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatIconModule } from '@angular/material/icon';
import { MatDialog } from '@angular/material/dialog';
import { DialogConfermaComponent } from '../dialog-conferma/dialog-conferma.component';
import { SicotService } from '../sicot.service';

@Component({
  selector: 'app-qualifiche',
  standalone: true,
  imports: [MatFormFieldModule, MatInputModule, MatTableModule, MatButtonModule, CommonModule, MatDatepickerModule, MatProgressBarModule, MatPaginatorModule, MatIconModule],
  templateUrl: './qualifiche.component.html',
  styleUrl: './qualifiche.component.css',
  providers: [provideNativeDateAdapter()],
})
export class QualificheComponent implements AfterViewInit{




  @Input() qualificaIntervento: any;

  @Output() qualificheId = new EventEmitter<any[]>();

  ngAfterViewInit() {
    if (this.dataSource)
    this.dataSource.paginator = this.paginator;
  }


  @ViewChild(MatPaginator) paginator: MatPaginator = new MatPaginator(new MatPaginatorIntl(), ChangeDetectorRef.prototype);


  qualifiche: Qualifica[] = [];
  selectedQualifiche: any[] = [];
  disponibilitaSessioneUVM: any[] = [];
  sessioneUVMScelta: Sessione | undefined;

  loadinDisponibilitaUVM: boolean = false;
  filtroDisponibilita: boolean = true;
  sceltaDisponibilita: boolean = false;

  displayedColumns: string[] = ['descrizione', 'action'];
  displayedColumnsDisponibilitaSessioneUVM: string[] = ['data', 'oraInizio', 'oraFine', 'struttura', 'operatoriBreve', 'action2'];
  dataSource: any;
  dataSoruceSelected: any;
  dataSoruceDisponibilitaSessioneUVM: any;
  mostraAggiungi: boolean = true;



  get mostraFiltroDisponibilita() {
    return this.filtroDisponibilita;
  }

  get mostraSceltaDisponibilita() {
    return this.sceltaDisponibilita;
  }

  get mostraCaricamentoDisponibilitaUVM() {
    return this.loadinDisponibilitaUVM;
  }

  constructor(private siCotService: SicotService) {

  }


  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    this.dataSource.paginator = this.paginator;
  }

  ngOnInit(): void {
    this.fetchQualifiche();
  }



  back() {
    this.sceltaDisponibilita = false;
    this.filtroDisponibilita = true;
  }
  

  fetchQualifiche(): void {
    this.siCotService.getQualifiche().subscribe(
      (data) => {
        this.qualifiche = data;
        this.dataSource = new MatTableDataSource<Qualifica[]>(data);
        this.dataSource.paginator = this.paginator;
      },
      (error) => {
        console.error('Error fetching qualifiche:', error);
      }
    );
    if (this.qualificaIntervento){
    this.siCotService.getQualificheByCodice(this.qualificaIntervento).subscribe(
      (data) => {
        if (data){
        this.addToSelected(data);
      }
      },
      (error) => {
        console.error('Error fetching qualifiche:', error);
      }
    );
  }
  }

  addToSelected(item: any): void {
    this.selectedQualifiche.push(item);
    this.dataSoruceSelected = new MatTableDataSource<Qualifica[]>(this.selectedQualifiche);
    this.mostraAggiungi = false
  }

  svuotaListaQualifiche() {
    this.selectedQualifiche = [];
    this.dataSoruceSelected = new MatTableDataSource<Qualifica[]>(this.selectedQualifiche);
    this.mostraAggiungi=true
  }

  rimuoviDaListaQualificheSelezionate(item: any) {
    console.log(item);
    if (item) {
      const index = this.dataSoruceSelected.data.indexOf(item);
      if (index > -1) {
        this.dataSoruceSelected.data.splice(index, 1);
        this.dataSoruceSelected = new MatTableDataSource(this.dataSoruceSelected.data);
        this.mostraAggiungi=true
      }
    }
  }

  saveQualifiche(){
    this.qualificheId.emit(this.selectedQualifiche)
  }
}




export interface Qualifica {
  id: number;
  codice: string;
  descrizione: string;
}

export interface Struttura {
  id: number;
  codice: string;
  descrizione: string;
}

export interface Operatore {
  id: string;
  cognome: string;
  nome: string;
  codiceFiscale: string;
  qualifica: Qualifica
}

export interface Sessione {
  id: number;
  data: string;
  oraInizio: string;
  oraFine: string;
  struttura: Struttura;
  operatoriBreve: string;
  operatori: Operatore[];
}


export interface DisponibilitaUVMRequest {
  durataSessioneUVM: number;
  dataInizioSessioneUVM: string;
  qualifiche: Qualifica[];
}

